import React, { useState, useEffect } from "react"; // Added useEffect for fetching stock
import { useNavigate } from "react-router-dom";
import { fetchWithAuth } from "../api/AuthApi.services";

// import Air from "../assets/vastu_gif/Air.webp";
// import Gift from "../assets/vastu_gif/Gift.webp";
// import Pet from "../assets/vastu_gif/Pet.gif";
// import Vastu from "../assets/vastu_gif/Vastu.gif";

import "./ProductCard.css";
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

function ProductCard({ product, onCartError, onCartSuccess ,col="" }) {
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [unitsInStock, setUnitsInStock] = useState(0); // Initialize unitsInStock as 0
  const navigate = useNavigate();

  // Fetch or set units_in_stock based on the product prop
  useEffect(() => {
    if ("units_in_stock" in product) {
      // If units_in_stock is already in the product prop, set it directly
      setUnitsInStock(product.units_in_stock || 0);
    } else {
      // Otherwise, fetch it from the API
      const fetchProductDetails = async () => {
        try {
          const accessToken = localStorage.getItem("accessToken");
          const headers = { "Content-Type": "application/json" };
          if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`;
          }
          const response = await fetch(
            `${API_BASE_URL}/product/products/${product.id}`,
            { method: "GET", headers }
          );
          if (response.ok) {
            const data = await response.json();
            setUnitsInStock(data.units_in_stock || 0);
          } else {
            throw new Error("Failed to fetch product details.");
          }
        } catch (error) {
          console.error("Error fetching product details:", error);
        }
      };
      fetchProductDetails();
    }
  }, [product.id, product]);

  const handleAddToCart = async (e) => {
    e.stopPropagation(); // Prevent the parent's onClick (handleViewDetails) from firing
    if (unitsInStock === 0) return; // Prevent adding if out of stock
    setIsAddingToCart(true);
    try {
      const guest_user_id = localStorage.getItem("guest_user_id");
      const accessToken = localStorage.getItem("accessToken");

      const headers = {
        "Content-Type": "application/json",
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`; // Fixed string interpolation
      }
      const body = {
        product: product.id,
      };

      if (guest_user_id) {
        body.guest_user_id = guest_user_id;
      }
      let response;
      if (accessToken) {
        response = await fetchWithAuth(`${API_BASE_URL}/order/carts/add-item/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      } else {
        response = await fetch(`${API_BASE_URL}/order/carts/add-item/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      }

      if (response.ok) {
        const data = await response.json();
        if (data.guest_user_id) {
          localStorage.setItem("guest_user_id", data.guest_user_id);
        }
        onCartSuccess(`${product.name} added to cart!`); // Fixed string interpolation
      } else {
        const errorData = await response.json();
        onCartError(errorData.error || "Failed to add to cart.");
      }
    } catch (error) {
      onCartError(error.error || "Failed to add to cart.");
    } finally {
      setIsAddingToCart(false);
    }
  };

  const handleViewDetails = () => {
    navigate(`/product-details/${product.id}`); // Fixed string interpolation
  };

  return (
    <div className={`${col ? col : "col-xxl-3 col-lg-3"} " col-md-4 col-sm-6 col-10 p-0"`}>
      <div className="product-card" onClick={handleViewDetails}>
      <p className="product-tag">{product.tagline}</p>

        <div className="ribbon red">
          <span>{product?.discount !== '0.00' ? `${product?.discount} % OFF` : ""}</span> {/* Fixed string interpolation */}
        </div>
        <div className="card-image">
          <img
            src={
              "https://vastuauraprod.s3.amazonaws.com/django-static/" +
              product.image
            }
            alt={product.name}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="card-details">
          {/* <p className="product-tag">{product.tagline}</p> */}
          <h5 className="product-name">{product.name}</h5>
          <div className="product-pricing">
            <span className="current-price">₹{product.currentPrice}</span>
            <span className="original-price">₹{product.originalPrice}</span>
            <span className="discount">({product.discount}% OFF)</span>
          </div>
          <div className="tag-container mb-2"> 
            {product.labels.map((label, index) => (
               <p key={index} className="tag-item">
                {/* <img src={Air} alt="logos" width="20px" height="auto" style={{ cursor: "pointer" }}/> */}
                  {label}
              </p>
            ))}

          </div>
          {unitsInStock > 0 ? (
            <button
              className="add-to-cart-btn"
              onClick={(e) => handleAddToCart(e)} // Pass the event to handleAddToCart
              disabled={isAddingToCart}
            >
              {isAddingToCart ? "Adding..." : "Add to Cart"}
            </button>
          ) : (
            <span
              className="out-of-stock"
              style={{
                display: "block",
                padding: "8px 12px",
                fontSize: "14px",
                fontWeight: "bold",
                color: "#ff0000",
                border: "none",
                borderRadius: "5px",
                cursor: "not-allowed",
                textAlign: "center",
              }}
            >
              Out of Stock
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;